import {connect} from 'react-redux';
import {AnyAction} from 'redux';
import {ThunkDispatch} from 'redux-thunk';

import NavigationProp from '../../../navigators/NavigationProp';

import Index, {
  DispatchProps,
  StateProps,
} from '../../../components/projects/episodes/Index';

import AppState from '../../../reducers/AppState';

import updateEpisodePublication, {
  Params as EpisodePublicationUpdateParams,
} from '../../../actions/episode_publications/update';

interface Props {
  navigation: NavigationProp;
}

const mapStateToProps = (state: AppState, props: Props): any => {
  const {navigation} = props;
  return {
    navigation,
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<AppState, void, AnyAction>,
) => {
  return {
    updateEpisodePublication: (
      id: number,
      params: EpisodePublicationUpdateParams,
    ) => dispatch(updateEpisodePublication(id, params)),
  };
};

export default connect<StateProps, DispatchProps, Props, AppState>(
  mapStateToProps,
  mapDispatchToProps,
)(Index);
